"use client";

import * as React from "react";
import Link from "next/link";
import { ChartCard, PreviewLineChart } from "@/components";
import { TrendingIcon } from "@/icons";
import { useStockToFlow } from "@/hooks/use-inflation";

export function Inflation() {
  const { data, isLoading } = useStockToFlow();
  const fields = React.useMemo(() => data?.chart?.fields, [data]);

  const lines = React.useMemo(() => {
    if (!fields) return [];
    return Object.keys(fields).map((el) => ({
      dataKey: el,
      name: fields[el].title,
      stroke: fields[el].color,
    }));
  }, [fields]);

  return (
    <Link href="/explore/inflation" className="block h-full cursor-pointer">
      <ChartCard
        title="Inflation"
        icon={<TrendingIcon size={20} color="#FF0F6F" />}
        isLoading={isLoading}
        accent="S2F"
        description="Supply and stock-to-flow dynamics"
      >
        <PreviewLineChart data={data?.data ?? []} lines={lines} />
      </ChartCard>
    </Link>
  );
}
